import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseAnchor',
  props: [`to`,`theme`,`text`],
  setup(__props) {

const props=__props

const type=computed(()=>{
  if(props.theme==`green`){
    return `#B9FF66`
  }else
  return props.theme
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "anchor",
    href: _ctx.to||null,
    style: _normalizeStyle({color:type.value})
  }, [
    _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ], 12, _hoisted_1))
}
}

})